import React, { memo, useEffect } from 'react';

interface SessionExpiredMessageProps {
  isVisible: boolean;
}

const SessionExpiredMessage: React.FC<SessionExpiredMessageProps> = ({
  isVisible,
}) => {
  if (!isVisible) return null;

  return (
    <div className="mb-6 p-4 bg-yellow-50 border border-yellow-400 rounded-md">
      <h3 className="text-lg font-medium text-yellow-800 mb-1">
        Session Expired
      </h3>
      <p className="text-yellow-700">
        Your session has ended due to inactivity.
      </p>
    </div>
  );
};

export default memo(SessionExpiredMessage);
